import * as React from 'react';
import {
  SocialLoginContext,
  SocialLoginsContextInfo,
} from '../core/reducers/context';

export function useSocialLogins(): SocialLoginsContextInfo {
  return React.useContext(SocialLoginContext);
}
